module.exports = __webpack_public_path__ + "img/logo.51050bd3.png";